import DownloadIcon from '@mui/icons-material/CloudDownloadOutlined'
import { IconButton, styled, Tooltip } from '@mui/material'
import { useParams } from 'react-router-dom'
import useBucketDownload from '../../../hooks/useBucketDownload'
import useSelectedMedia from '../../../hooks/useSelectedMedia'

const PillButton = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  color: '#fff',
  fontWeight: 500,
  fontSize: '0.875rem',
  cursor: 'pointer',
  gap: 8
})

export default function MediaDownloadPillButton() {
  const { bucketId } = useParams<{ bucketId: string }>()
  const { selectedMedia } = useSelectedMedia()
  const { downloadSingleMedia, downloadMultipleMedia, downloadMultipleMediaResults, downloadSingleMediaResults } = useBucketDownload()
  const mediaIds: string[] = Array.from(selectedMedia.keys())
  const loading = downloadMultipleMediaResults.loading || downloadSingleMediaResults.loading

  const handleClick = () => {
    if (!bucketId || !mediaIds.length) return

    if (mediaIds.length > 1) {
      downloadMultipleMedia(bucketId, mediaIds)
      return
    }

    downloadSingleMedia(bucketId, mediaIds[0])
  }

  const disabled = !mediaIds.length || loading

  if (disabled) {
    return null
  }

  return (
    <Tooltip title={selectedMedia.size ? 'Download Media' : 'No Media Selected'} arrow>
      <PillButton as="span">
        <IconButton
          disabled={disabled}
          onClick={handleClick}
          color="primary"
          aria-label="Download"
          data-test="download"
          id="download-pill-button"
          sx={{ color: '#fff' }}
        >
          <DownloadIcon />
        </IconButton>
        <span style={{ color: disabled ? 'rgba(0, 0, 0, 0.38)' : '#fff' }}>Download</span>
      </PillButton>
    </Tooltip>
  )
}
